export function initFilters() {
	document.addEventListener("DOMContentLoaded", () => {
		document.addEventListener("change", handleFilterChange);
		document.addEventListener("click", handleChipClick);
		document.addEventListener("click", handleClearAllClick);
		document.addEventListener("click", handlePaginationClick);
		window.addEventListener("popstate", () => {
			updateFromUrl(window.location.href);
		});
	});

	/**
	 * Gestisce il cambio nei filtri (checkbox, select, ecc.)
	 * Viene triggerato da qualsiasi elemento dentro #JsFacetFiltersForm
	 */
	function handleFilterChange(event) {
		const form = event.target.closest("#JsFacetFiltersForm");
		if (!form) return;

		const formData = new FormData(form);
		updateFilters(formData);
	}

	/**
	 * Gestisce il click su un singolo chip (filtro attivo)
	 * Rimuove quel valore dall'URL e aggiorna i risultati via AJAX
	 */
	function handleChipClick(event) {
		if (!event.target.matches(".js-filter-chip")) return;

		const param = event.target.dataset.param;
		const value = event.target.dataset.value;

		const url = new URL(window.location.href);
		const params = url.searchParams;

		// Rimuove solo il valore selezionato
		const updatedValues = params.getAll(param).filter((v) => v !== value);
		params.delete(param);
		updatedValues.forEach((v) => params.append(param, v));

		const formData = new FormData();
		for (const [key, val] of params.entries()) {
			formData.append(key, val);
		}

		updateFilters(formData);
	}

	/**
	 * Gestisce il click su "Rimuovi tutti i filtri"
	 * Elimina tutti i parametri che iniziano con "filter." dall'URL
	 */
	function handleClearAllClick(event) {
		if (!event.target.matches(".js-clear-all-filters")) return;
		event.preventDefault();

		// console.log("[CLEAR] Click ricevuto – si inizia il reset");

		const url = new URL(window.location.href);
		const params = url.searchParams;

		// console.log("[CLEAR] URL prima della pulizia:", url.href);

		// Rimuove tutti i filtri attivi
		[...params.keys()]
			.filter((key) => key.startsWith("filter."))
			.forEach((key) => {
				// console.log(
				// 	`[CLEAR] Rimuovo parametro "${key}" con valore "${params.getAll(
				// 		key
				// 	)}"`
				// );
				params.delete(key);
			});

		const cleanUrl = `${url.pathname}${
			params.toString() ? "?" + params.toString() : ""
		}`;
		history.pushState({}, "", cleanUrl);

		// console.log("[CLEAR] URL dopo la pulizia:", cleanUrl);

		updateFromUrl(cleanUrl);

		// console.log("[CLEAR] Chiamata a updateFromUrl()");
	}

	/**
	 * Gestisce la paginazione AJAX
	 */
	function handlePaginationClick(event) {
		const link = event.target.closest(".pagination a");
		if (!link) return;

		event.preventDefault();
		const url = link.href;

		history.pushState({}, "", url);
		updateFromUrl(url);
	}

	/**
	 * Genera l'URL dai dati del form e avvia la richiesta AJAX
	 */
	function updateFilters(formData) {
		const params = new URLSearchParams(formData).toString();
		const url = `${window.location.pathname}?${params}`;
		history.pushState({}, "", url);
		updateFromUrl(url);
	}

	/**
	 * Esegue una richiesta AJAX alla URL indicata
	 * e aggiorna i blocchi prodotti, filtri e chip attivi nel DOM
	 */
	function updateFromUrl(url) {
		// Mostra stato di caricamento globale
		document.body.classList.add("is-loading");

		const container = document.querySelector(".js-collection-products");

		fetch(url)
			.then((res) => res.text())
			.then((html) => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, "text/html");

				// Aggiorna i prodotti
				const newProducts = doc.querySelector(
					".js-collection-products"
				);
				const oldProducts = document.querySelector(
					".js-collection-products"
				);
				if (newProducts && oldProducts) {
					oldProducts.innerHTML = newProducts.innerHTML;
				}

				// Aggiorna il form dei filtri
				const newForm = doc.getElementById("JsFacetFiltersForm");
				const oldForm = document.getElementById("JsFacetFiltersForm");
				if (newForm && oldForm) {
					oldForm.innerHTML = newForm.innerHTML;
				}

				// Aggiorna i chip dei filtri attivi
				const newChips = doc.querySelector(".js-active-filters");
				if (newChips) {
					document
						.querySelectorAll(".js-active-filters")
						.forEach((dest) => {
							dest.innerHTML = newChips.innerHTML;
						});
				}

				// Aggiorna il titolo e descrizione della collezione
				const newHeader = doc.getElementById("JsCollectionHeader");
				const oldHeader = document.getElementById("JsCollectionHeader");
				if (newHeader && oldHeader) {
					oldHeader.innerHTML = newHeader.innerHTML;
				}

				if (oldProducts) oldProducts.classList.remove("loading");

				if (container) {
					const y =
						container.getBoundingClientRect().top +
						window.pageYOffset -
						260;
					window.scrollTo({ top: y, behavior: "smooth" });
				}
			})
			.catch((err) => {
				console.error("updateFromUrl error:", err);
			})
			.finally(() => {
				// Rimuovi sempre lo stato di caricamento
				document.body.classList.remove("is-loading");
			});
	}
}
